<div class="flex" [ngClass]="{'sidebar-active': app.sidebarActive}">
    <div class="sidebar-next-right-block">
        <partner-orders *ngIf="activeMenu === menuEnum.AllOrder" [menuPermissionActive]="menuPermissionActive"></partner-orders>
        <partner-orders-feedback *ngIf="activeMenu === menuEnum.Feedback" [menuPermissionActive]="menuPermissionActive"></partner-orders-feedback>
    </div>
</div>

<p-toast position="top-right"></p-toast>
